import React, { useRef, useState, useEffect } from 'react'
import Box from '../Student/Widget/Components/Box'
import FrecuencyObservations from './Components/FrecuencyObservation'


const EducatorDashboard = () => {

    const currentLessonsWidget = useRef(null)
    const [clientRect, setClientRect] = useState(currentLessonsWidget?.current?.getBoundingClientRect())
    //actualiza las dimensiones del `widget currently on going lessons`
    useEffect(() => {
        if (currentLessonsWidget?.current?.getBoundingClientRect()?.height !== clientRect?.height) {
            setClientRect(currentLessonsWidget?.current?.getBoundingClientRect())
        }
        //eslint-disable-next-line
    }, [currentLessonsWidget?.current?.getBoundingClientRect()])




    // const defaultBox = { colLg: 6, colXl: 6, colMd: 6, colSm: 12 }
    // const studentWithoutLessonsBox = { colLg: 6, colXl: 6, colMd: 6, colSm: 12, onScroll: () => {console.log("ahora si")} }

    // const issueCheckInBox = { colLg: 3, colXl: 3, colMd: 6, colSm: 12, height: '650px', minHeight: '100%', maxHeight: '650px' }

    // const testDateBox = { colLg: 4, colXl: 4, colMd: 12, colSm: 12, height: '500px' }
    const defaultBox = { colLg: 12, colXl: 12, colMd: 12, colSm: 12, height: '100%' }
    



    return (
        <div className={`column`}>

            <Box {...defaultBox}>
                <FrecuencyObservations />
            </Box>
        </div>
    )
}

export default EducatorDashboard